import { render, staticRenderFns } from "./OrdersPhysical.vue?vue&type=template&id=8781aff0"
import script from "./OrdersPhysical.vue?vue&type=script&lang=js"
export * from "./OrdersPhysical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports